import React from 'react';
import Months from './Months';
import ClassNames from 'classnames';
var YearView = function YearView(props) {
  var keyboradHighlight = props.keyboradHighlight;
  var className = ClassNames('ap-calendar__year-view', {
    "keyboard-date-view-inner-highlight": keyboradHighlight
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Months, props));
};
export default YearView;